/* eslint-disable check-file/filename-blocklist -- pre-existing .jsx; this change only swaps colour values for dark mode, converting to .tsx is a separate migration */
import {
  Menu,
  Flex,
  MenuButton,
  Text,
  Icon,
  MenuList,
  MenuItem,
  Box,
} from '@chakra-ui/react';
import { useField } from 'formik';
import { ChevronDown } from '@kula-ai/icons-core';

export const MenuField = ({ item = {} }) => {
  const {
    name,
    options = {},
    placeholder,
    menuLabelStyles,
    menuDescStyles,
    showMenuRightContent = false,
    MenuRightComp = <></>,
  } = item;
  const [_field, meta, helpers] = useField(name); // eslint-disable-line
  const { setValue } = helpers;
  const selectedValue = options?.find((type) => type?.value === meta?.value);

  const onChange = (type) => {
    setValue(type?.value);
  };

  return (
    <Menu matchWidth={true}>
      <MenuButton as={Flex} flex="1" cursor="pointer">
        <Flex
          alignItems="center"
          border="1px solid var(--kula-dark-secondary-100, #E5E5E5)"
          borderRadius="8px"
          p="6px 12px"
          flex="1"
          justifyContent="space-between"
          h="40px"
        >
          {selectedValue?.label ? (
            <Text fontSize="14px">{selectedValue?.label}</Text>
          ) : (
            <Text fontSize="sm" color="ats-text-secondary">
              {placeholder || ''}
            </Text>
          )}
          <Icon as={ChevronDown} />
        </Flex>
      </MenuButton>

      <MenuList p="6px" maxH="250px" overflowY="auto">
        {options?.map((type) => {
          return (
            <MenuItem
              onClick={() => onChange(type)}
              key={type?.value}
              _hover={{ background: 'ats-tertiary' }}
              _focus={{ background: 'ats-tertiary' }}
              p="10px"
              w="100%"
              flex="1"
            >
              <Flex gap="3px" w="inherit" alignItems="center">
                <Box flex="1">
                  <Text {...menuLabelStyles}>{type?.label}</Text>
                  {type?.desc && <Text {...menuDescStyles}>{type?.desc}</Text>}
                </Box>
                {showMenuRightContent && <MenuRightComp value={type?.value} />}
              </Flex>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
